import React from 'react';
import { initials } from '../../utils/format';
import { accentFor } from '../../utils/constants';

/** Initials avatar (rounded square). tone: auto (accent picked from the name) | teal | blue | sand | on-primary */
export default function Avatar({ name, src, size, tone = 'auto', className = '' }) {
  const toneCls = tone === 'auto' ? `accent--${accentFor(name)}` : tone !== 'teal' && `avatar--${tone}`;
  const cls = ['avatar', size && `avatar--${size}`, toneCls, className]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={cls} aria-hidden="true">
      {src ? <img src={src} alt="" /> : initials(name)}
    </span>
  );
}
